import React from 'react'

import {Provider} from 'react-redux'

import {AppStore, makeStore} from '../redux/store'

export default function StoreProvider({children}: {children: React.ReactNode}) {
  const storeRef = React.useRef<AppStore>(null)

  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore()

    if (process.env.NODE_ENV !== 'production') {
      // Expose the dev store to the window for debugging
      window.store = storeRef.current
    }
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}
